import React, { ReactNode } from "react";
import useAuth from "../hooks/useAuth";

interface PrivateComponentProps {
  children?: ReactNode;
}

const PrivateComponent = ({ children }: PrivateComponentProps) => {
  const { currentAdmin } = useAuth();

  if (!currentAdmin) {
    return null;
  }
  return <>{children}</>;
};

export default PrivateComponent;
